import { useState, useEffect, forwardRef, Fragment } from 'react';
import {
  Grid,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import { TableColumnCell } from 'src/components/TableColumnCell';
import { withStyles } from '@mui/styles';
import { TableHeaderCell } from 'src/components/TableHeaderCell';

interface AllocationTableProps {
  resource: any,
  mainProjectManager: any
}

const AllocationTable = forwardRef((props: AllocationTableProps, _ref) => {

  const validateProjectManager = (projectManagerId: string) => {
    if(projectManagerId) {
      if(projectManagerId === props?.mainProjectManager?.projectManagerId) {
        return '#FFC300';
      }
    }
  }

  const CustomTableRow = withStyles({
    root: {
      background: '#E6E9FF !important',
      height: '3.5rem'
    }
  })(TableRow);

  return (
    <Fragment>
      <Grid item style={{ paddingBottom: '1rem', paddingTop: '2rem' }}>
        <div style={{ paddingLeft: '15px', paddingRight: '15px', display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="h3" style={{ fontSize: '12px' }}>Project Allocation - Within The Selected Date Period</Typography>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center'}}>
            <div style={{
              background: '#FFC300',
              borderRadius: '50%',
              width: '7px',
              height: '7px'
            }}></div>
            <Typography variant="h3" style={{ fontSize: '12px' }}>Approver</Typography>
          </div>
        </div>
      </Grid>
      <TableContainer className="tableContainer">
        <Table style={{ borderCollapse: 'separate' }} size="small">
          <TableHead>
            <CustomTableRow>
              <TableHeaderCell content="Project Name" smallFont />
              <TableHeaderCell content="Type" smallFont />
              <TableHeaderCell content="Allocation" smallFont />
              <TableHeaderCell content="Project Manager" smallFont />
            </CustomTableRow>
          </TableHead>
          <TableBody>
            {props?.resource?.allocations.length > 0 ? (
              <>
                {props?.resource?.allocations.map((item) => (
                  <TableRow hover>
                    <TableColumnCell>
                      <Typography
                        paddingBottom="0.25rem"
                        paddingTop="0.5rem"
                        variant="body2"
                        style={{ fontSize: '11px' }}
                        gutterBottom
                        noWrap
                      >
                        {item.projectName}
                      </Typography>
                    </TableColumnCell>
                    <TableColumnCell>
                      <Typography
                        paddingBottom="0.25rem"
                        paddingTop="0.5rem"
                        variant="body2"
                        style={{ fontSize: '11px' }}
                        gutterBottom
                        noWrap
                      >
                        {item.type}
                      </Typography>
                    </TableColumnCell>
                    <TableColumnCell>
                      <Typography
                        paddingBottom="0.25rem"
                        paddingTop="0.5rem"
                        variant="body2"
                        style={{ fontSize: '11px' }}
                        color="text.primary"
                        gutterBottom
                        noWrap
                      >
                        {item.allocation}%
                      </Typography>
                    </TableColumnCell>
                    <TableColumnCell>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px'}}>
                        <div style={{
                          background: validateProjectManager(item?.projectManagerId),
                          borderRadius: '50%',
                          width: '7px',
                          height: '7px'
                        }}
                        ></div>
                        <Typography
                          paddingBottom="0.25rem"
                          paddingTop="0.5rem"
                          variant="body2"
                          color="text.primary"
                          gutterBottom
                          noWrap
                          style={{fontSize: '11px'}}
                        >
                          {item?.projectManager ? item.projectManager : '-'}
                        </Typography>
                      </div>
                    </TableColumnCell>
                  </TableRow>
                ))}
              </>
            ) : (
              <>
                <TableRow>
                  <TableColumnCell colSpan={4}>
                    <Typography
                      textAlign='center'
                      paddingBottom="0.25rem"
                      paddingTop="0.5rem"
                      variant="body2"
                      color="text.primary"
                      gutterBottom
                      noWrap
                      style={{fontSize: '11px'}}
                    >
                      No record data
                    </Typography>
                  </TableColumnCell>
                </TableRow>
              </>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Fragment>
  );
});

export default AllocationTable;
